import React, { useState, useEffect, useMemo} from 'react';
import moment from 'moment';

import { toast } from 'react-toastify';
import useAlmaXStudentsRefresh from '../useAlmaXStudentsRefresh';

import ProgressBar from '../../../all-users/_components/progress-bar/component';

import { useLocation, useHistory } from 'react-router-dom';
import LoadingCircleIcon from '../../../../icons/LoadingCircle';
import {
  generateCourseCertificateUrl,
  getCourseProgress,
  updateAlmaxExpiryDate,
  getAllConstants,
  updateAlmaxUserStatus,
  updateAlmaxCohort,
} from '../../../../services/apiService';

import Progress from './_tabs/progress';
import Profile from './_tabs/profile';
import AuditLogs from './_tabs/audit-logs';
import UploadIsa from './_tabs/upload-isa';

import { ArrowBack } from '@material-ui/icons';
import ExtendAlmaxExpiryDateModal from '../../../all-users/user-details/_modals/ExtendAlmaxExpiryDateModal';

function UserBasicDetails({ userParams }) {
  return (
    <div
      style={{
        backgroundColor: 'var(--card-background, #fff)',
        borderRadius: 16,
        padding: '20px 24px',
        width: 384,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
        boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))',
      }}
    >
      <div style={{ display: 'flex', gap: 8 }}>
        <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Id:</span>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{userParams.User?.id}</span>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Name:</span>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>
          {userParams?.User?.firstName} {userParams?.User?.lastName}
        </span>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Course:</span>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>
          {userParams?.User?.UserSubscriptions[0]?.courseType}
        </span>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Plan Type:</span>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>
          {userParams?.User?.UserSubscriptions[0]?.planType}
        </span>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>ERL Date:</span>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>
          {moment(userParams?.UserSubscriptions_createdOn).format(
            'DD MMM YYYY'
          )}
        </span>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Cohort:</span>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>
          {userParams?.User?.UserSubscriptions[0]?.cohortName}
        </span>
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Phone:</span>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>
          {userParams?.User?.phone || '—'}
        </span>
        {userParams?.User?.isPhoneVerified != null && (
          userParams.User.isPhoneVerified ? (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12, fontWeight: 600, color: '#2563EB' }}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="7" fill="#2563EB"/><path d="M4 7L6 9.5L10 5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
              Verified
            </span>
          ) : (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12, fontWeight: 600, color: '#9CA3AF' }}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="7" fill="#D1D5DB"/><path d="M4.5 4.5L9.5 9.5M9.5 4.5L4.5 9.5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/></svg>
              Unverified
            </span>
          )
        )}
      </div>
    </div>
  );
}
const getGoalType = (courseType) => {
  if (courseType === 'data-engineering') return 'dataEngineering';
  if (courseType === 'data-science') return 'dataScience';
  if (courseType === 'web3') return 'web3';
  return null;
};
function UserProgressDetails({ userParams, setUploadIsaData, refreshTrigger, onMutationComplete }) {
  const [progressResp, setProgressResp] = useState(null);
  const [openExtendAlmaxModal, setOpenExtendAlmaxModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openCohortModal, setOpenCohortModal] = useState(false);
  const [selectedCohort, setSelectedCohort] = useState('');
  const [cohortOptions, setCohortOptions] = useState([]);
  const [tagOptions, setTagOptions] = useState([]);
  const [cohortLoading, setCohortLoading] = useState(false);
  const [tagLoading, setTagLoading] = useState(false);
  // Add these states at the top of your component
const [cohortSearchQuery, setCohortSearchQuery] = useState('');

// Add this filtered cohort logic



const filteredCohortOptions = useMemo(() => {
  if (!cohortSearchQuery.trim()) {
    return cohortOptions;
  }
  
  const query = cohortSearchQuery.toLowerCase();
  return cohortOptions.filter((cohort) =>
    cohort.name.toLowerCase().includes(query)
  );
}, [cohortSearchQuery, cohortOptions]);

  const [openTagModal, setOpenTagModal] = useState(false);
  const [selectedTag, setSelectedTag] = useState('');
  const [cohortRemoveLoading, setCohortRemoveLoading] = useState(false);

  const fetchStatusProgress = async (goalType, userId) => {
    try {
      console.log(goalType, userId, 'goalType, userId');
      const progressResp = await getCourseProgress(goalType, userId);
      setUploadIsaData(progressResp?.userAlmaxStatus);
      setProgressResp(progressResp);
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch data');
    }
  };
  // async function handleUpdateUserStatus({
  //   payload,
  //   closeModal,
  //   refresh,
  //   successMsg = 'Updated successfully!',
  //   errorMsg = 'Update failed!',
  // }) {
  //   try {
  //     const response = await updateAlmaxUserStatus(payload);
  //     if (response) {
  //       closeModal();
  //       toast.success(successMsg);
  //     }
  //     if (refresh) await refresh();
  //   } catch (e) {
  //     toast.error(errorMsg);
  //   }
  // }
  async function handleUpdateCohort() {
    setCohortLoading(true);
    const cohortObj = cohortOptions.find((c) => c.id === selectedCohort);
    if (!cohortObj) {
      toast.error('Please select a valid cohort');
      setCohortLoading(false);
      return;
    }
    const payload = {
      userEmails: [userParams?.User?.email],
      almaXCohort: {
        almaxCohortName: cohortObj?.name,
        almaxCohortId: cohortObj?.id,
      },
      courseType: cohortObj?.courseType,
    };
    try {
      const response = await updateAlmaxCohort(payload);
      if (response && response.updatedUsers && response.updatedUsers[0]) {
        // Update selectedCohort to the new value from response
        setSelectedCohort(response.updatedUsers[0].almaxCohortId || '');
        toast.success('Cohort updated successfully!');
        setOpenCohortModal(false);

        fetchStatusProgress(
          getGoalType(userParams?.courseType),
          userParams?.userId
        );
        onMutationComplete?.();
      } else {
        toast.error('Failed to update Cohort');
      }
    } catch (e) {
      toast.error('Error updating Cohort');
    } finally {
      setCohortLoading(false);
    }
  }
  async function handleRemoveCohort() {
    setCohortRemoveLoading(true);

    const payload = {
      userEmails: [userParams?.User?.email],
      almaXCohort: {},
      courseType: userParams?.courseType,
    };
    try {
      const response = await updateAlmaxCohort(payload);
      if (response && response.updatedUsers && response.updatedUsers[0]) {
        // Update selectedCohort to the new value from response
        setSelectedCohort(response.updatedUsers[0].almaxCohortId || '');
        toast.success('Cohort Removed successfully!');
        setOpenCohortModal(false);
        fetchStatusProgress(
          getGoalType(userParams?.courseType),
          userParams?.userId
        );
        onMutationComplete?.();
      } else {
        toast.error('Failed to update Cohort');
      }
    } catch (e) {
      toast.error('Error updating Cohort');
    } finally {
      setCohortRemoveLoading(false);
    }
  }
  async function handleUpdateTag() {
    setTagLoading(true);
    const payload = {
      userId: userParams?.userId,
      courseType: userParams?.courseType,
      almaXStatus: selectedTag,
    };
    try {
      const response = await updateAlmaxUserStatus(payload);
      if (response) {
        toast.success('Tag updated successfully!');
        setOpenTagModal(false);
        fetchStatusProgress(
          getGoalType(userParams?.courseType),
          userParams?.userId
        );
        onMutationComplete?.();
      } else {
        toast.error('Failed to update Tag');
      }
    } catch (e) {
      toast.error('Failed to update Tag');
    } finally {
      setTagLoading(false);
    }
  }
  const handleGenerateCertificate = async () => {
    try {
      setLoading(true);
      const payload = {
        userId: userParams?.userId,
        courseType: userParams?.courseType,
      };

      const response = await generateCourseCertificateUrl(payload);
      if (response?.successful === true) {
        await fetchStatusProgress(
          getGoalType(userParams?.courseType),
          userParams?.userId
        );
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error('Error Occured');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    console.log(userParams?.courseType, 'aksdfnasd');
    fetchStatusProgress(
      getGoalType(userParams?.courseType),
      userParams?.userId
    );
  }, [refreshTrigger, userParams?.courseType, userParams?.userId]);

  useEffect(() => {
    console.log(userParams, 'userpara');
    async function fetchConstants() {
      try {
        const res = await getAllConstants();
        // Map cohorts to { id, name }
        const cohorts = (res?.allCohorts || []).filter((c) => c.courseType === userParams?.courseType).map((c) => ({
          id: c.cohortId,
          name: c.cohortName,
          courseType: c.courseType
        }));
        setCohortOptions(cohorts);

        // Map tags to { id, name }
        const tagsObj = res?.data?.tags || {};
        const tags = Object.entries(tagsObj).map(([name, id]) => ({
          id,
          name,
        }));
        setTagOptions(tags);
      } catch (e) {
        setCohortOptions([]);
        setTagOptions([]);
      }
    }
    fetchConstants();
  }, []);
  const handleExtendButtonClicked = async (date) => {
    try {
      await updateAlmaxExpiryDate({
        userId: userParams.userId,
        courseType: getGoalType(userParams.courseType),
        date,
      });
      fetchStatusProgress(
        getGoalType(userParams?.courseType),
        userParams?.userId
      );
      setOpenExtendAlmaxModal(false);
      onMutationComplete?.();
    } catch (e) {
      console.error(e);
      let message;
      if ([400, 500].includes(e.response?.status) && e.response?.data?.message)
        message = e.response.data.message;
      else message = 'Error extending date';
      toast.error(message);
    }
  };

  return (
    <div
      style={{
        backgroundColor: 'var(--card-background, #fff)',
        borderRadius: 16,
        padding: '20px 24px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
        boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))',
      }}
    >
      <ExtendAlmaxExpiryDateModal
        open={openExtendAlmaxModal}
        onClose={() => {
          setOpenExtendAlmaxModal(false);
        }}
        onExtendClicked={handleExtendButtonClicked}
      />
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div style={{ width: '40%', fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>AlmaX Course Progress</div>
        <div style={{ width: '100%' }}>
          <ProgressBar
            progress={(progressResp?.almaXCourseProgress || 0) / 100}
            bold={true}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div style={{ width: '40%', fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Course Progress</div>
        <div style={{ width: '100%' }}>
          <ProgressBar
            progress={(progressResp?.courseProgress || 0) / 100}
            bold={true}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div style={{ width: '40%', fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>ProX Progress</div>
        <div style={{ width: '100%' }}>
          <ProgressBar
            progress={(progressResp?.proXProgress || 0) / 100}
            bold={true}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div style={{ width: '40%', fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>SSP Progress</div>
        <div style={{ width: '100%' }}>
          <ProgressBar
            progress={(progressResp?.sspProgress || 0) / 100}
            bold={true}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div style={{ width: '40%', fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Total Certificates</div>
        <div style={{ width: '100%', fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>
          {progressResp?.totalCertificates || 0}
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginTop: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <div style={{ width: '33%', fontSize: 13, fontWeight: 500, color: 'var(--text-primary, #111827)' }}>Almax Expiry Date</div>
          <div style={{ width: '33%', fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>
            {progressResp?.userABCATData?.expiryDate
              ? moment(progressResp?.userABCATData?.expiryDate).format(
                  'DD MMM YYYY'
                )
              : 'No Expiry Date Yet'}
          </div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center', width: '33%' }}>
            <button
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: '#fff',
                backgroundColor: 'var(--primary-main, #4F46E5)',
                border: 'none',
                borderRadius: 4,
                padding: '6px 12px',
                cursor: 'pointer',
              }}
              onClick={() => setOpenExtendAlmaxModal(true)}
            >
              Extend
            </button>
            <button
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: '#fff',
                backgroundColor: '#059669',
                border: 'none',
                borderRadius: 4,
                padding: '6px 12px',
                cursor: 'pointer',
              }}
              onClick={() => {
                // Find the cohortId from userParams.UserSubscriptions[0] (or the correct subscription)
                const currentCohortId =
                  userParams?.User?.UserSubscriptions?.[0]?.almaxCohortId;
                if (currentCohortId) {
                  setSelectedCohort(currentCohortId);
                } else {
                  setSelectedCohort('');
                }
                setOpenCohortModal(true);
              }}
            >
              AlmaX Cohort
            </button>

            <button
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: '#fff',
                backgroundColor: '#7C3AED',
                border: 'none',
                borderRadius: 4,
                padding: '6px 12px',
                cursor: 'pointer',
              }}
              onClick={() => {
                const currentTag = userParams?.almaxStatus;
                if (currentTag) {
                  setSelectedTag(currentTag);
                } else {
                  setSelectedTag('');
                }
                setOpenTagModal(true);
              }}
            >
              Tag
            </button>
          </div>
        </div>
{openCohortModal && (
  <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-2'>
    <div className='bg-white rounded-xl shadow-2xl p-6 w-full max-w-md border border-gray-200 relative'>
      <h2 className='text-xl font-bold mb-4'>Select AlmaX Cohort</h2>
      
      {/* Search Input */}
      <input
        type='text'
        className='w-full border border-gray-300 rounded px-3 py-2 mb-2 focus:outline-none focus:ring-2 focus:ring-purple-500'
        placeholder='Search cohorts...'
        value={cohortSearchQuery}
        onChange={(e) => setCohortSearchQuery(e.target.value)}
      />
      
      {/* Dropdown with filtered options */}
      <select
        className='w-full border border-gray-300 rounded px-3 py-2 mb-6'
        value={selectedCohort}
        onChange={(e) => setSelectedCohort(e.target.value)}
        size={Math.min(5, filteredCohortOptions.length + 1)}
      >
        <option value=''>Select Cohort</option>
        {filteredCohortOptions.map((cohort) => (
          <option key={cohort.id} value={cohort.id}>
            {cohort.name}
          </option>
        ))}
      </select>
      
      {filteredCohortOptions.length === 0 && cohortSearchQuery && (
        <p className='text-sm text-gray-500 mb-4 -mt-4'>No cohorts found</p>
      )}
      
      <div className='flex justify-between gap-4'>
        <div className='flex justify-start gap-2'>
          {cohortRemoveLoading ? (
            <span className='flex items-center'>
              <LoadingCircleIcon iconStyle='w-2 h-2 mr-2 animate-spin' />
              Removing...
            </span>
          ) : (
            <button
              className='px-4 py-2 text-white bg-red-600 rounded hover:bg-red-500'
              onClick={handleRemoveCohort}
            >
              Remove From Almax
            </button>
          )}
        </div>
        <div className='flex justify-end gap-2'>
          <button
            className='px-4 py-2 bg-gray-200 rounded hover:bg-gray-300'
            onClick={() => {
              setOpenCohortModal(false);
              setCohortSearchQuery('');
            }}
          >
            Cancel
          </button>
          <button
            className='px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700 flex items-center justify-center'
            onClick={handleUpdateCohort}
            disabled={!selectedCohort || cohortLoading}
          >
            {cohortLoading ? (
              <span className='flex items-center'>
                <LoadingCircleIcon iconStyle='w-2 h-2 mr-2 animate-spin' />
                Saving...
              </span>
            ) : (
              'Save'
            )}
          </button>
        </div>
      </div>
    </div>
  </div>
)}
        {openTagModal && (
          <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-2'>
            <div className='bg-white rounded-xl shadow-2xl p-6 w-full max-w-md border border-gray-200 relative'>
              <h2 className='text-xl font-bold mb-4'>Select Tag</h2>
              <select
                className='w-full border border-gray-300 rounded px-3 py-2 mb-6'
                value={selectedTag}
                onChange={(e) => setSelectedTag(e.target.value)}
              >
                <option value=''>Select Tag</option>
                {tagOptions.map((tag) => (
                  <option key={tag.id} value={tag.id}>
                    {tag.name}
                  </option>
                ))}
              </select>
              <div className='flex justify-end gap-2'>
                <button
                  className='px-4 py-2 bg-gray-200 rounded hover:bg-gray-300'
                  onClick={() => setOpenTagModal(false)}
                >
                  Cancel
                </button>
                <button
                  className='px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700 flex items-center justify-center'
                  onClick={handleUpdateTag}
                  disabled={!selectedTag || tagLoading}
                >
                  {tagLoading ? (
                    <span className='flex items-center'>
                      <LoadingCircleIcon iconStyle='w-5 h-5 mr-2 animate-spin' />
                      Saving...
                    </span>
                  ) : (
                    'Save'
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div>
        {(progressResp?.proXProgress === 100 ||
          progressResp?.courseProgress === 100) &&
        progressResp?.certificateId === null ? (
          <button
            onClick={handleGenerateCertificate}
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: loading ? 'var(--text-disabled, #9CA3AF)' : 'var(--primary-main, #4F46E5)',
              backgroundColor: 'var(--card-background, #fff)',
              border: `1px solid ${loading ? 'var(--text-disabled, #9CA3AF)' : 'var(--primary-main, #4F46E5)'}`,
              borderRadius: 4,
              padding: '8px 16px',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.5 : 1,
            }}
            disabled={loading}
          >
            Generate Certificate
          </button>
        ) : null}
      </div>
    </div>
  );
}

function UserDetails() {
  const location = useLocation();
  const history = useHistory();
  const { refreshGridData } = useAlmaXStudentsRefresh();

  const [tab, setTab] = useState('profile');
  const [userParams, setUserParams] = useState(null);
  const [uploadIsaData, setUploadIsaData] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  console.log(userParams, 'userParams');

  useEffect(() => {
    const userParams = location.state?.userParams;
    if (!userParams) {
      history.replace('/all-users');
      return;
    }
    setUserParams(userParams);
  }, []);
  if (!userParams) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Header */}
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <ArrowBack
          style={{ cursor: 'pointer', color: 'var(--text-primary, #111827)' }}
          onClick={() => {
            history.goBack();
          }}
        />
        <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--heading-primary, #111827)', margin: 0 }}>
          Student Details
        </h1>
      </div>

      {/* Cards */}
      <div style={{ display: 'flex', gap: 16 }}>
        <UserBasicDetails userParams={userParams} />
        <UserProgressDetails userParams={userParams} setUploadIsaData={setUploadIsaData} refreshTrigger={refreshTrigger} onMutationComplete={refreshGridData} />
      </div>

      {/* Tab container */}
      <div
        style={{
          backgroundColor: 'var(--card-background, #fff)',
          borderRadius: 16,
          padding: '0 20px',
          border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
          boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))',
        }}
      >
        {/* Tab menu */}
        <div style={{ display: 'flex', gap: 32, borderBottom: '1px solid var(--border-light, rgba(0,0,0,0.07))' }}>
          <h2
            style={{
              fontSize: 14,
              fontWeight: tab === 'profile' ? 600 : 400,
              color: tab === 'profile' ? 'var(--primary-main, #4F46E5)' : 'var(--text-secondary, #6B7280)',
              cursor: 'pointer',
              padding: '12px 0',
              margin: 0,
              borderBottom: tab === 'profile' ? '2px solid var(--primary-main, #4F46E5)' : '2px solid transparent',
              transition: 'all 150ms ease',
            }}
            onClick={() => setTab('profile')}
          >
            Profile
          </h2>
          <h2
            style={{
              fontSize: 14,
              fontWeight: tab === 'progress' ? 600 : 400,
              color: tab === 'progress' ? 'var(--primary-main, #4F46E5)' : 'var(--text-secondary, #6B7280)',
              cursor: 'pointer',
              padding: '12px 0',
              margin: 0,
              borderBottom: tab === 'progress' ? '2px solid var(--primary-main, #4F46E5)' : '2px solid transparent',
              transition: 'all 150ms ease',
            }}
            onClick={() => setTab('progress')}
          >
            Progress
          </h2>
          <h2
            style={{
              fontSize: 14,
              fontWeight: tab === 'auditLogs' ? 600 : 400,
              color: tab === 'auditLogs' ? 'var(--primary-main, #4F46E5)' : 'var(--text-secondary, #6B7280)',
              cursor: 'pointer',
              padding: '12px 0',
              margin: 0,
              borderBottom: tab === 'auditLogs' ? '2px solid var(--primary-main, #4F46E5)' : '2px solid transparent',
              transition: 'all 150ms ease',
            }}
            onClick={() => setTab('auditLogs')}
          >
            Audit Logs
          </h2>
          <h2
            style={{
              fontSize: 14,
              fontWeight: tab === 'uploadIsa' ? 600 : 400,
              color: tab === 'uploadIsa' ? 'var(--primary-main, #4F46E5)' : 'var(--text-secondary, #6B7280)',
              cursor: 'pointer',
              padding: '12px 0',
              margin: 0,
              borderBottom: tab === 'uploadIsa' ? '2px solid var(--primary-main, #4F46E5)' : '2px solid transparent',
              transition: 'all 150ms ease',
            }}
            onClick={() => setTab('uploadIsa')}
          >
            Upload ISA
          </h2>
        </div>
      </div>

      {tab === 'profile' && <Profile />}

      {tab === 'progress' && <Progress />}

      {tab === 'auditLogs' && <AuditLogs />}
      {tab === 'uploadIsa' && (
        <UploadIsa 
          userParams={userParams} 
          uploadIsaData={uploadIsaData} 
          setRefreshTrigger={setRefreshTrigger} 
        />
      )}
    </div>
  );
}

export default UserDetails;
